<template>
  <div>
    <h5 class="mb-4 flex items-center">
      <feather-icon icon="CheckCircleIcon" class="mr-4" svg-classes="text-success" />
      Сгенерировано: {{ success }}
    </h5>
    <h5 class="mb-4 flex items-center">
      <feather-icon icon="AlertTriangleIcon" class="mr-4" svg-classes="text-danger" />
      Ошибок: {{ denied }}
    </h5>
    <table class="w-full" v-if="errors && errors.length">
      <thead>
      <tr>
        <th class="p-0">Лицевой счет</th>
        <th class="p-0">Ошибка</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(error, index) in errors" :key="`key-${index}`">
        <td>{{ error.acc_num }}</td>
        <td>{{ err_codes[error.code] }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:   "InvoicesGenerateLogPopup",
  mixins: [notifyHttpError],
  props:  ['historyItem'],
  data() {
    const { historyItem } = this;
    let log = JSON.parse(historyItem.log);
    return {
      success:   historyItem.success,
      denied:    historyItem.denied,
      errors:    log.errors,
      err_codes: log.err_codes,
    };
  },
};
</script>

<style lang="scss" module>

</style>
